import React, { useEffect, useState, useContext, Fragment } from "react";
import "./ChanelOwnerInfos.scss";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import i18n from "i18next";

import { UserContext } from "../../api/user/userContext";
import { Avatars, nFormatter, slug } from "../../api/ReplayVariables";

function ChanelOwnerInfos({ chanelOwner, onSubscribed, onShowLogin }) {
  const { user } = useContext(UserContext);
  const { t } = useTranslation();
  const [canvas, setCanvas] = useState(null);

  const letters = [
    "a",
    "z",
    "e",
    "r",
    "t",
    "y",
    "u",
    "i",
    "o",
    "p",
    "q",
    "s",
    "d",
    "f",
    "g",
    "h",
    "j",
    "k",
    "l",
    "m",
    "w",
    "x",
    "c",
    "v",
    "b",
    "n"
  ];

  const getAvatar = (pseudo) => {
    let letter = pseudo.substring(0, 1).toLowerCase();
    if (letters.indexOf(letter) !== -1) {
      return Avatars["avatar" + letter.toUpperCase()];
    } else {
      return Avatars.avatarA;
    }
  };

  const toggleSubscription = () => {
    if (user !== null && user.id > 0) {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body:
          "id=" +
          chanelOwner.id +
          "&id_slug=" +
          slug(chanelOwner.username) +
          "&my_slug=" +
          slug(user.username) +
          "&lng=" +
          i18n.language +
          "&subscribed=" +
          !chanelOwner.subscribed
      };
      fetch(window.serverUrl+`/social/subscribe.php`, requestOptions)
        .then((r) => r.json())
        .then((resp) => {
          console.log("resp", resp);
          onSubscribed(resp);
        })
        .catch((err) => {
          console.error("fetch problem", err);
        });
    } else {
      //show login
      onShowLogin();
    }
  };

  useEffect(() => {
    //console.log("chanelOwner", chanelOwner);

    if (chanelOwner.canvas && chanelOwner.canvas !== canvas) {
      const img = document.createElement("img");
      img.style.display = "none";
      document.body.appendChild(img);

      img.onload = () => {
        //console.log("size", img);
        //if (this.width >= 2048 && this.height >= 335) {
        setCanvas(chanelOwner.canvas);
        //} else {
        //  setCanvas(null);
        //}
        document.body.removeChild(img);
      };
      img.onerror = () => {
        //console.log("table " + index + " loaded");
        document.body.removeChild(img);
        setCanvas(null);
      };
      img.src =
        window.serverUrl+"/images/comprofiler/" + chanelOwner.canvas;
    }
    return () => {};
  }, [user, canvas, chanelOwner]);
  return (
    <div className="chanel-owner-container d-flex">
      {canvas ? (
        <div
          className="owner-header"
          style={{
            backgroundAttachment: "fixed",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundImage: `url(${window.serverUrl}/images/comprofiler/${canvas})`
          }}
        ></div>
      ) : (
        <></>
      )}
      <div className="chanel-owner d-flex flex-column">
        <div className="owner d-flex flex-row align-items-center">
          <div className="owner-details-container d-flex flex-row">
            {chanelOwner.avatar ? (
              <img
                className="avatar-image"
                src={
                  window.serverUrl+"/media/kunena/avatars/" +
                  chanelOwner.avatar
                }
                alt="avatar"
              />
            ) : (
              <img
                className="avatar"
                src={getAvatar(chanelOwner.username)}
                alt=""
              />
            )}

            <div className="owner-details d-flex flex-column">
              <div className="name">{chanelOwner.username}</div>
              <div className="subscribers">
                {nFormatter(chanelOwner.subscribers)}{" "}
                {t(
                  chanelOwner.subscribers > 1
                    ? "replayApp.subscribers"
                    : "replayApp.subscriber"
                )}
              </div>
              <div className="replays">
                {nFormatter(chanelOwner.replays)}{" "}
                {t(
                  chanelOwner.replays > 1
                    ? "replayApp.user_replays"
                    : "replayApp.user_replay"
                )}
              </div>
            </div>
          </div>
          {user !== null &&
          user.firstLoad === false &&
          user.id !== chanelOwner.id ? (
            <div className="replay-actions flex-row">
              <Button
                className="subscribe"
                disabled={user.id === chanelOwner.id}
                onClick={toggleSubscription}
              >
                {t(
                  chanelOwner.subscribed && user.error !== 401
                    ? "replayApp.unsubscribe"
                    : "replayApp.subscribe"
                )}
              </Button>
            </div>
          ) : user !== null &&
            user.firstLoad === false &&
            user.id === chanelOwner.id ? (
            <div className="replay-actions flex-row">
              <>
                <Button
                  className="edit"
                  href={"/opencards/" + i18n.language + "/settings/infos"}
                >
                  {t("chanelApp.edit")}
                </Button>
              </>
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="description">
          {chanelOwner.cb_description ? (
            chanelOwner.cb_description.split("\n").map((split, index) => (
              <Fragment key={index}>
                {split}
                <br />
              </Fragment>
            ))
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChanelOwnerInfos;
